// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/astroturf/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n  ._28mF98z4gM6RA9OdY-YuEy {\n    color: white;\n    background: black;\n    border-radius: 4px;\n    padding: 8px;\n  }\n", ""]);
// Exports
exports.locals = {
	"tooltip": "_28mF98z4gM6RA9OdY-YuEy"
};
module.exports = exports;
